import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class LoginGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const isLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";

    if (isLoggedIn) {
      const confirmLogout = confirm("Do you want to logout?");
      if (confirmLogout) {
        sessionStorage.clear();
        localStorage.clear();
        return true;
      } else {
        this.router.navigate(["/dashboard"]);
        return false;
      }
    }

    return true;
  }
}
